export const FACTS = 'facts';
export const STORY = 'story';
export const DESIGN = 'design';

const steps = [FACTS, STORY, DESIGN];

export default steps;
